import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';
import { GraphicsService } from 'src/app/services/graphics.service';
import { LoadingAkanaService } from 'src/app/services/loading-akana.service';
import { trigger, style, animate, transition } from '@angular/animations';
import { CONSTANTS } from 'src/app/shared/constants';

declare let Chart;


@Component({
  standalone: false,
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(1300, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class StatsComponent implements OnInit {

  data: any;
  dataCards: any;
  currentTab = 1;
  cards = [];
  graphic: any;
  showLoading = false;

  constructor(private readonly gs: GraphicsService, private c: CommonsService, private r: Router, private l: LoadingAkanaService) { }

  ngOnInit() {

    this.c.firstChargePage('Stats', 'Vista estadisticas', 'content');
    this.c.eventsAnalitics('visit screen', 'Graficos estadisticos', 'Stats');
    if (!this.data) {
      this.showLoadingMethod(true);
      this.gs.getGraphics().subscribe(data => {
        setTimeout(() => {
          document.querySelector('body').style.overflow = '';
          this.showLoadingMethod(false);
        }, CONSTANTS.timeLoading);
        if (data.Code === 401) {
          this.c.openModalSession();
          return;
        }
        sessionStorage.setItem('gs', JSON.stringify(data));
        this.data = data;
        this.dataCards = data;
        this.initGraphic();
        this.calculateMiniKPIs();
      }, (error) => {
        this.c.openModalSession();
      });
    } else {
      this.calculateMiniKPIs();
      this.initGraphic();
    }
  }

  /**
   * se inicia el grafico
   * @param data datos para rellenar el grafico
   */
  initGraphic = (num?) => {
    this.graphic = new Chart(document.getElementById('myChart'), {
      type: 'line',
      data: this.getObjectGraphic(this.data, num),
      options: {
        tooltips: {
          enabled: false
        },
        scales: {
          yAxes: [{
            ticks: {
              callback: (value, index, values) => {
                return value + ' €';
              }
            }
          }]
        }
      }
    });
  }

  /**
   * coge los nombres de los meses
   * @param data: any
   */
  getMonthName = (data) => {
    const months = [];
    data.filter(d => {
      months.push(d.Description.split('Gastos fijos mes de ')[1].toUpperCase());
    });
    return months;
  }

  /**
   * Devuelve una objeto/lista de los acumulados
   * @param data: any
   * @param negative: bolean
   */
  getAcum = (data, negative) => {
    const arrayValue = [];
    let aux = 0;

    data.filter(d => {
      aux = aux + d.ValueC;
      arrayValue.push(negative ? aux * (-1) : aux);
    });
    return arrayValue;
  }

  /**
   * Detecta cuando es vista mensual y cuando vista de acumulado
   * @param data: any
   * @param acumulado: boolean
   * @param negative: boolean
   */
  getArrayValues = (data, acumulado, negative) => {
    let arrayValues = [];
    if (!acumulado) {
      data.filter(d => {
        arrayValues.push(negative ? d.ValueC * (-1) : d.ValueC);
      });
    } else {
      arrayValues = this.getAcum(data, negative);
    }
    return arrayValues;
  }


  /**
   * Genera el grafico necesario para mostrar en el canvas
   * @param data: any
   * @param acu: boolean
   */
  getObjectGraphic = (data, acu) => {
    return {
      datasets: [
        {
          label: 'Ingresos',
          data: this.getArrayValues(data.Ingr, acu, false),
          backgroundColor: [
            'rgba(32, 206, 0, 0)'
          ],
          borderColor: [
            'rgba(32, 206, 0)'
          ],
        },
        {
          label: 'Gastos Fijos',
          data: this.getArrayValues(data.Gafi, acu, true),
          backgroundColor: [
            'rgba(255, 206, 86, 0)',
          ],
          borderColor: [
            '#FF9816'
          ],
        },
        {
          label: 'Gastos Variables',
          data: this.getArrayValues(data.Gava, acu, true),
          backgroundColor: [
            'rgba(255, 206, 86, 0)'
          ],
          borderColor: [
            '#FF1616'
          ],
        },
        {
          label: 'Ahorro',
          data: this.getArrayValues(data.Ahor, acu, false),
          backgroundColor: [
            'rgba(75, 192, 192, 0.2)',
          ],
          borderColor: [
            '#16C5FF'
          ],
        },
        {
          label: 'Saldo en cuenta',
          data: this.getArrayValues(data.Posm, false, false),
          backgroundColor: [
            'rgba(255, 206, 86, 0)'
          ],
          borderColor: [
            '#7D7D7D'
          ],
        }
      ],
      labels: this.getMonthName(data.Gafi)
    };
  }


  /**
   * cambia el tab actual para cambiar los valores en
   * @param tab: numb
   */
  changeGraphicView = (tab) => {
    if (tab === this.currentTab) {
      return;
    }
    this.graphic.destroy();
    if (tab === 1) {
      this.currentTab = tab;
      this.initGraphic(false);
      this.c.eventsAnalitics('click', 'Ver grafico', 'Grafico anual');
    } else {
      this.c.eventsAnalitics('click', 'Ver Grafico', 'Grafico acumulado');
      this.currentTab = tab;
      this.initGraphic(true);
    }
  }


  calculateMiniKPIs = () => {
    this.cards = this.getCard();
  }


  getCard = () => {
    return [
      {
        name: 'Ingresos',
        values: [
          {
            name: 'Media',
            value: this.media(this.dataCards.Ingr)
          },
          {
            name: 'Max.',
            value: this.max(this.dataCards.Ingr)
          },
          {
            name: 'Min.',
            value: this.min(this.dataCards.Ingr)
          }
        ]
      },
      {
        name: 'G. Fijos',
        values: [
          {
            name: 'Media',
            value: this.media(this.dataCards.Gafi, true)
          },
          {
            name: 'Max.',
            value: this.max(this.dataCards.Gafi, true)
          },
          {
            name: 'Min.',
            value: this.min(this.dataCards.Gafi, true)
          }
        ]
      },
      {
        name: 'G. Variables',
        values: [
          {
            name: 'Media',
            value: this.media(this.dataCards.Gava, true)
          },
          {
            name: 'Max.',
            value: this.max(this.dataCards.Gava, true)
          },
          {
            name: 'Min.',
            value: this.min(this.dataCards.Gava, true)
          }
        ]
      },
      {
        name: 'Ahorro',
        values: [
          {
            name: 'Media',
            value: this.media(this.dataCards.Ahor)
          },
          {
            name: 'Max.',
            value: this.max(this.dataCards.Ahor)
          },
          {
            name: 'Min.',
            value: this.min(this.dataCards.Ahor)
          }
        ]
      },
      {
        name: 'Saldo',
        values: [
          {
            name: 'Media',
            value: this.media(this.dataCards.Posm)
          },
          {
            name: 'Max.',
            value: this.max(this.dataCards.Posm)
          },
          {
            name: 'Min.',
            value: this.min(this.dataCards.Posm)
          }
        ]
      }];
  }

  max = (d, g?) => {
    const m = [];
    let name = '';
    let max = 0;
    d.filter(i => {
      m.push(i.ValueC);
    });
    max = Math.max(m[0], m[1], m[2], m[3], m[4], m[5], m[6], m[7], m[8], m[9], m[10], m[11]);
    d.filter(i => {
      if (max === i.ValueC) {
        const pos = i.Description.split(' ');
        name = pos[pos.length - 1];
      }
    });
    return { month: name, value: g ? -1 * Math.round(max) : Math.round(max), valor: 'MÁXIMO' };
  }

  min = (d, g?) => {
    const m = [];
    let min = 0;
    let name = '';
    d.filter(i => {
      m.push(i.ValueC);
    });
    min = Math.min(m[0], m[1], m[2], m[3], m[4], m[5], m[6], m[7], m[8], m[9], m[10], m[11]);
    d.filter(i => {
      if (min === i.ValueC) {
        const pos = i.Description.split(' ');
        name = pos[pos.length - 1];
      }
    });
    return { month: name, value: g ? -1 * Math.round(min) : Math.round(min), valor: 'MÍNIMO' };
  }

  media = (data: any, g?) => {
    let aux = 0;
    data.filter(d => {
      aux = aux + d.ValueC;
    });

    return g ? -1 * Math.round(aux / data.length) : Math.round(aux / data.length);
  }

  /**
   * muestra o esconde el loading akana
   * @param value: boolean
   */
  private showLoadingMethod = (value: boolean) => {
    this.showLoading = value;
    if (!value) {
      document.querySelector('body').style.overflow = '';
    }
  }
}
